import React, { useEffect } from "react";
import AboutImg from '../Images/About.jpg';
import UrlTag from "../components/UrlTag";
import { Link } from "react-router-dom";

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="z-20">
            <UrlTag />
            <div className="relative">
                <img src={AboutImg} alt="About" className="w-full h-[300px] md:h-[500px] object-cover" />
                <div className="absolute inset-0 bg-black opacity-40"></div>
                <div className="absolute bottom-0 left-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-14">
                    <h1 className="text-white text-3xl sm:text-4xl font-bold">About</h1>
                </div>
            </div>
            <div className="p-4 sm:p-8 md:p-16 max-w-[620px] mx-auto">
                <h1 className="text-2xl mb-4 tracking-tight">
                    About Architetive Designs
                </h1>
                <p className="text-lg mb-8 tracking-wider text-gray-700 font-light">
                    Architetive Designs is a global studio for sustainable architecture, urbanism, engineering, and design, founded in 2010.
                </p>
                <div className="bg-[#f5f5f5] p-4 sm:p-8 mb-16">
                    <p className="text-lg font-light text-gray-700 mb-4">
                        “From the very beginning, our practice was founded on a philosophy of innovation, sustainability, and design. We continue to learn from the past and creatively embrace the challenges of the future, with a firm belief that good design makes a difference.”
                    </p>
                    <div>
                        <p className="tracking-wide text-lg font-semibold">
                            Founder and Executive Chairman
                        </p>
                    </div>
                </div>
                <div className="mb-10">
                    <h1 className="text-2xl font-semibold mb-4">Practice Structure</h1>
                    <p className="text-gray-800 text-lg font-light tracking-wide">
                        The partners, who are all shareholders, are the core of the practice. They are central to our continuing evolution and take responsibility for all projects, which are shared amongst our architectural studios. Maintaining the design ethos of the practice, the Design Board reviews every project at all its different stages. Day-to-day management of the practice is provided by the Management Board, which is drawn from the wider group of senior partners and partners. The Partnership Board then oversees the strategic direction of the entire practice.
                    </p>
                </div>
                <div className="mb-8">
                    <h1 className="text-2xl font-semibold mb-4">Integrated Design</h1>
                    <p className="text-gray-800 text-lg font-light tracking-wide">
                        We believe that good, responsible design is only possible with significant contributions from different disciplines. This allows us to rapidly explore a wide range of solutions from many points of view. Our architectural teams design and deliver projects from the earliest sketch through to strategic design, construction drawings, and completion. They work closely with our specialist design teams throughout the process to deliver an integrated vision. These teams include structural and environmental engineering, sustainability, urban and landscape design, industrial design, workplace and interior design, together with our own technology and research teams.
                    </p>
                </div>
                <div className="flex flex-col sm:flex-row gap-4">
                    <Link to='/expertise'>
                        <button className="bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Discover our Expertise</button>
                    </Link>
                    <Link to='/people'>
                        <button className="bg-[#eeeeee] hover:bg-[#e6e6e6] rounded-full px-4 py-2">Learn about our teams</button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default About;